module.exports = __webpack_public_path__ + "static/media/5.4b5c69bb.jpg";